<template>
  <div class="viewingResults">
      <div class="head">
          <h1>{{getReadOverDetailData.subject}}</h1>
      </div>
      <div class="msg">
          <div class="item"> 
              <span>开始时间：{{getReadOverDetailData.begintime}}</span>
              <span>交卷时间：{{getReadOverDetailData.submittime}}</span>
          </div>

          <div class="item info" v-if="getReadOverDetailData.ischeckover == 0 && getReadOverDetailData.ischeckbyhand == 1">
            <i class="el-icon-warning"></i>
            <span>本试卷含有主观题，请等待批阅后查看分数和答案。</span>
          </div>
          <!-- end 批阅中展示 -->

          <div class="pf">
              <div class="round">
                  <p class="name" v-if="getReadOverDetailData.ischeckover == 0 && getReadOverDetailData.ischeckbyhand == 1">阅卷中</p>
                  <p class="name" v-else>{{getReadOverDetailData.examtotalscore}}</p>
                  <p class="sename">试卷得分</p>
              </div>
              

              <ul class="list">
                <li>
                    <img src="~common/images/examination/icon-shijuan (1).png" alt="shijuan">
                    <p>答题时间</p>
                    <p><span class="color-red">{{getReadOverDetailData.factexamtime}}</span>分</p>
                </li>
                 <li>
                    <img src="~common/images/examination/icon-shijuan (2).png" alt="shijuan">
                    <p>正确题数</p>
                    <p><span class="color-red">{{getReadOverDetailData.finalrightcount}}</span>题</p>
                </li>
                 <li>
                    <img src="~common/images/examination/icon-shijuan (3).png" alt="shijuan">
                    <p>错误题数</p>
                    <p><span class="color-red">{{getReadOverDetailData.finalfailcount}}</span>题</p>
                </li>
                 <li>
                    <img src="~common/images/examination/icon-shijuan (4).png" alt="shijuan">
                    <p>答题数目</p>
                    <p><span><i class="color-red">{{getReadOverDetailData.answercount}}</i>/{{getReadOverDetailData.totalcount}}</span>题</p>
                </li>
              </ul>
          </div>

      </div>
      <div class="btnlist">
          <el-button type="primary" @click="answer" v-if="getReadOverDetailData.isshow == 1">查看答案解析</el-button>
          <el-button type="primary" v-if="getReadOverDetailData.isshowreturndetail" plain @click="gotoDetails">返回详情</el-button>
          <el-button type="primary" plain @click="closePage">关闭页面</el-button>

          <!-- <el-popover
            style="margin-left: 30px"
            popper-class="viewingResults-qrcode"
            placement="top-start"
            width="148"
            trigger="hover">
            <div id="qrcode"></div>
            <p>手机刷题更轻松</p>
            <el-button slot="reference" type="primary" plain>手机刷题</el-button>
        </el-popover> -->
          
      </div>
  </div>
</template>

<script>
import QRCode  from "qrcodejs2"
import {mapActions} from 'vuex'
import {getReadOverDetail} from 'api/questionbank'
export default {
  name: 'viewingResults',
  data () {
    return {
        exampid: this.$route.query.examid,  // 题库id
        getReadOverDetailData: {}   // 订阅数据 
    }
  },
  mounted () {
      this.initGetReadOverDetail()
  },
  methods: {
      closePage() {
          window.close()
      },
      qRCode() { // 分享二维码生成
            // console.log(window.location.origin+'/m/courseView?cid='+this.$route.query.cid)
            new QRCode('qrcode', {
                width: 100,
                height: 100, // 高度
                text: window.location.origin+'/m/PaperDetails?qid='+ this.getReadOverDetailData.assetinnerid,   // 二维码内容
            })
        },
        initGetReadOverDetail() {   // 获取批阅详情
            this.setLoading(true)
            getReadOverDetail({
                data: {exampid: this.exampid},
                success: data => {
                    this.setLoading(false)
                    this.getReadOverDetailData = data.data

                    // 二维码生成
                    this.qRCode()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        gotoDetails() { // 返回详情 
            if (this.getReadOverDetailData.topiccode === 'jjcy') {
                this.$router.replace({name: 'StartTopic', query: {code: 'jjcy'}})
            } else {
                this.$router.replace({name: 'QuestionDetails', query: {qid: this.getReadOverDetailData.assetinnerid}})
            }
        },
        answer() {  // 查看答案解析
            this.$router.push({name: 'ExaminationInterface', query: {examid: this.exampid, bankid: this.getReadOverDetailData.assetinnerid, page: 1}})
        },
        ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.viewingResults {
    margin-top: 30px;
    margin: auto;
    width: 1200px;
    max-height: 636px;
    background: #fff;

    
    .head {
        padding: 40px 20px;
        border-bottom: dotted 1px #E5E5E5;
        h1 {
            font-size: 24px;
            text-align: center;
        }
    }
    .msg {
        margin-top: 29px;
        .item {
            margin: auto;
            width: 456px;

            span {
                color: #909399;
                font-size: 14px;
                & + span {
                    float: right;
                }
            }

            &.info {
                padding: 12px 10px;
                margin-top: 17px;
                // height:44px;
                background:rgba(253,246,236,1);
                border-radius:4px;
                background: #FDF6EC;
                box-sizing: border-box;
                span {
                    color: #E6A23C;
                }
                .el-icon-warning {
                    margin-right: 10px;
                    color: #E6A23C;
                }
            }
        }
        .pf {
            margin-top: 63px;
            padding-bottom: 60px;
            border-bottom: dotted 1px #e5e5e5;
            overflow: hidden;
            .round {
                float: left;
                margin-left: 351px;
                width:190px;
                height:190px;
                background:rgba(255,255,255,1);
                border:5px solid rgba(239,239,239,1);
                border-radius: 50%;
                text-align: center;
                .name {
                    margin-top: 70px;
                    font-size:24px;
                    color: #FF4747;
                }
                .sename {
                    font-size: 14px;
                    margin-top: 26px;
                }
            }
            .list {
                float: left;
                margin-left: 60px;
                li {
                    width: 234px;
                    height: 30px;
                    &~li {
                        margin-top: 20px;
                    }
                }
                img,
                p {
                    float: left;
                }
                img {
                    margin-right: 12px;
                    width: 30px;
                    height: 30ox;
                }
                p,span {
                    line-height: 30px;
                }
                p~p {
                    float: right;
                }
                p span {
                    margin-right: 9px;
                }
                .color-red {
                    color: #FF4747;
                    font-style: normal;
                }
            }
        }
    }
    .btnlist {
        padding: 40px 0;
        text-align: center;
        .el-button {
            width: 180px;
        }
        .el-button ~ .el-button {
            margin-left: 30px;
        }
    }
}
    .viewingResults-qrcode {
        img {
            margin: auto;
        }
        p {
            margin-top: 6px;
            text-align: center;
        }
    }
</style>